import { useHistory } from 'react-router';
import type { CreateLeverandorProcessRequest } from '@klp/leverandor/services/rtkApi';
import { useCreateLeverandorProcessMutation } from '@klp/leverandor/services/rtkApi';
import i18n from 'i18next';
import { LeverandorRoutes } from '@klp/leverandor/config';
import { showToast } from '@klpkonsern/ui';

interface Props {
    request: CreateLeverandorProcessRequest;
    onClose: () => void;
}

export const useStartProsess = () => {
    const [createLeverandor, { isLoading }] =
        useCreateLeverandorProcessMutation();
    const history = useHistory();

    const startProcess = async ({ request, onClose }: Props) => {
        try {
            const d = await createLeverandor(request).unwrap();
            onClose();

            showToast({
                body: i18n.t('prosjekt.successfulOperation'),
                type: 'success',
            });

            if (d.prosessInstansId) {
                history.push(
                    LeverandorRoutes.leverandorSchemaSingle(d.prosessInstansId),
                );
            }
        } catch {
            showToast({ body: i18n.t('general.error.message'), type: 'error' });
            onClose();
        }
    };

    return { startProcess, isLoading };
};
